import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import Strings from "../utils/stringUtil";
import theme from "../utils/themeUtil";
import TextSize from "../utils/textSizeUtil";
import { isMobile } from "../utils/responsiveUtil";
import styles from "../assets/styles/main.module.css";
import Seo from "../components/seo";
import withLoader from "../components/ui/withLoader";

const TranscorpTnc = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const tabStyles = {
    "&.Mui-selected": {
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.white.main,
      minHeight: "46px",
      padding: "0px 40px",
      textTransform: "capitalize",
    },
    "&:not(.Mui-selected)": {
      backgroundColor: theme.palette.grey2.main,
      color: theme.palette.black.main,
      minHeight: "46px",
      padding: "0px 40px",
      textTransform: "capitalize",
    },
  };

  return (
    <React.Fragment>
      <Seo title={Strings.mahilaMoney} description={Strings.description} />

      <Box
        bgcolor={theme.palette.lightWhite.main}
        py={isMobile ? 2 : 5}
        textAlign="left"
      >
        <Box className={styles.container}>
          <Typography
            style={{
              fontSize: isMobile ? TextSize.size18 : TextSize.size24,
              fontWeight: "bold",
              color: theme.palette.black.main,
            }}
          >
            {Strings.transcorpTnC}
          </Typography>
          <Box mt={4}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: theme.palette.blue.main,
                },
              }}
            >
              <Tab label={Strings.english} sx={tabStyles} />
              <Tab label={Strings.hindi} sx={tabStyles} />
            </Tabs>
            <Box
              style={{ fontSize: "14px", textAlign: "left" }}
              dangerouslySetInnerHTML={{
                __html:
                  tabValue === 0
                    ? Strings.transcodeTncContent
                    : Strings.transcodeTncContentHindi,
              }}
            ></Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default withLoader(TranscorpTnc);
